<template>

    <input 
      v-if="!tableData[tableDataIndex]['jt-summary']" 
      type="checkbox"
      v-model="tableData[tableDataIndex][tableParameter[tableParameterIndex].key]"
      v-on:click="onTableCustomClick"
      v-on:input="onTableCustomInput"
      v-on:change="onTableCustomChange" />

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageBillCollectionSelect",
  props: ['tableData', 'tableDataIndex', 'tableParameter', 'tableParameterIndex'],
  components: {
  },
  data () {
    return {
      permission : null,
    }
  },
  methods: {
    onTableCustomClick() {
      this.$emit('table-cell-click');
    },
    onTableCustomInput() {
      setTimeout(() => {
        this.$emit('table-cell-input');
      }, 100)
    },
    onTableCustomChange() {
      this.$emit('table-cell-change');
      if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        this.$emit('table-cell-input');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageBillCollectionSelect.vue